/**
 * Rewrites the add-to-cart error shown on Simple Bundles product pages.
 *
 * Simple Bundles keeps a bundle's stock at what its component designs allow, so
 * the bundle runs out for reasons the customer cannot see: one low-stock design
 * picked in several slots needs more of it than is left, or what is already in
 * the cart has taken the rest. Shopify answers /cart/add.js with 422 and a
 * description naming the bundle ("'<bundle>' is sold out", or a partial-add
 * count), which theme.js drops into a .errors box — reading as "this set is
 * gone" when the fix is to pick fewer duplicates or check the cart.
 *
 * Replacing every add-to-cart error here is safe rather than guesswork on the
 * cause: a bundle already sold out when the page rendered gets a disabled button
 * from product-form.liquid, so the box only appears once an add has failed. And
 * with no quantity field on these pages every add is for one bundle, so the
 * replacement never has to stand in for a partial-add message.
 */
(function () {
  'use strict';

  var config = window.bundleCartErrorConfig || {};
  var message = (config.message || '').trim();
  if (!message) return;

  var FORM_SELECTOR = 'form[action*="/cart/add"]';

  // One paragraph per line of the setting. Several sentences running together as
  // one centred block is what makes this box hard to read, so the copy is broken
  // up here — what happened, why, then what to try — rather than styled as a
  // single run of text.
  var lines = message.split('\n').map(function (line) {
    return line.trim();
  }).filter(Boolean);

  function rewrite(box) {
    if (!box || box.dataset.bundleErrorRewritten === '1') return;
    box.dataset.bundleErrorRewritten = '1';

    box.textContent = '';
    lines.forEach(function (line, index) {
      var paragraph = document.createElement('p');
      paragraph.className = index === 0 ? 'bundle-error__lead' : 'bundle-error__detail';
      paragraph.textContent = line;
      box.appendChild(paragraph);
    });
  }

  function rewriteAll() {
    Array.prototype.forEach.call(document.querySelectorAll(FORM_SELECTOR), function (form) {
      Array.prototype.forEach.call(form.querySelectorAll('.errors'), rewrite);
    });
  }

  // theme.js dispatches this synchronously right after appending the box, so the
  // original text is replaced before the browser gets a chance to paint it.
  document.addEventListener('ajaxProduct:error', rewriteAll);

  // Backstop for any other path that renders the box — a server-rendered error
  // on a non-ajax submit, or the app inserting its own.
  function watch() {
    rewriteAll();
    new MutationObserver(rewriteAll).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
